export default {
    name: 'heroSection',
    title: 'Hero Section',
    type: 'document',
    fields: [
        { name: 'title', title: 'Title', type: 'blockContent', validation: Rule => Rule.required() },
        { name: 'subtitle', title: 'Subtitle', type: 'text', validation: Rule => Rule.required() },
        { name: 'heroImage', title: 'Hero Image', type: 'image', options: { hotspot: true }, validation: Rule => Rule.required() }
    ],
    preview: {
        select: {
            media: 'heroImage'
        },
        prepare({ media }) {
            return {
                title: 'Hero Section',
                subtitle: 'Homepage hero section content',
                media
            }
        }
    }
} 